import React from "react"
import "./priceslider.scss"
import text from "../styles/typography.module.scss"

class PriceSlider extends React.Component {
  state = {
    priceInputValue: "0",
    priceInput: {
      0: 1,
      1: 10,
      2: 20,
      3: 30,
      4: 40,
      5: 50,
    },
    priceOutput: {
      eur: {
        0: ["5,21", "eur", "5,21"],
        1: ["49,5", "eur", "4,9"],
        2: ["96,7", "eur", "4,8"],
        3: ["146,5", "eur", "4,8"],
        4: ["194", "eur", "4,8"],
        5: ["234,6", "eur", "4,69"],
      },
      dkk: {
        0: ["40", "dkk"],
        1: ["381", "dkk"],
        2: ["746", "dkk"],
        3: ["1.128", "dkk"],
        4: ["1.493", "dkk"],
        5: ["1.806", "dkk"],
      },
    },
  }

  componentDidMount() {
    this.slider.current.setAttribute("min", 0)
    this.slider.current.setAttribute(
      "max",
      Object.keys(this.state.priceInput).length - 1
    )
  }

  slider = React.createRef()

  handlePriceSlide = e => {
    this.setState({ priceInputValue: e.target.value })
  }

  getPriceData = (obj, pos) => {
    return pos !== undefined
      ? obj[this.state.priceInputValue][pos]
      : obj[this.state.priceInputValue]
  }

  render() {
    return (
      <div>
        <div>
          <input
            type="range"
            defaultValue={this.state.priceInputValue}
            ref={this.slider}
            onChange={this.handlePriceSlide}
          />
          <datalist id="meetings">
            <option>1</option>
            <option>10</option>
            <option>20</option>
            <option>30</option>
            <option>40</option>
            <option>50</option>
          </datalist>
        </div>
        <div className="price-output">
          <span className={`${text.display} price`}>
            {this.getPriceData(this.state.priceOutput.eur, 0)}
          </span>
          <span className={`${text.heading1} currency`}> €</span>
          <div className={`${text.subdisplay}`} style={{ fontSize: "16px" }}>
            {this.getPriceData(this.state.priceOutput.eur, 2)} € / meeting
          </div>
          <br />
          <a className="link" href="#plans">
            {" "}
            Looking for business plan?
          </a>
        </div>
      </div>
    )
  }
}

export default PriceSlider
